import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const subtitle = css`
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const actions = css`
  display: flex;
  flex-direction: row;
  gap: ${spacing(2)};
`

export const helpGuideIcon = css`
  width: 16px;
  height: 16px;
`
